// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"421264e3","703":"3fbdecae","787":"8045125b"}[chunkId] + ".chunk.js";
};